import { AriaAttributes, forwardRef, ReactNode, Ref } from 'react';

import clsx from 'clsx';
import { Editable, Slate } from 'slate-react';
import { EditableProps } from 'slate-react/dist/components/editable';

import ElementNode from '../ElementNode';
import LeafNode from '../LeafNode';
import { Root } from './styles';
import useRichTextView, { RichTextViewRef, VMProps } from './vm';

export interface Props extends VMProps, AriaAttributes {
  id?: string;
  children?: ReactNode;
  className?: string;
  classes?: Partial<Record<'root' | 'editable', string>>;
  tabIndex?: number;
  slateEditableProps?: EditableProps;
}

const RichTextView = (
  { children, className, classes, tabIndex, richtext, slateEditableProps, ...props }: Props,
  ref: Ref<RichTextViewRef>
) => {
  const { editor, value } = useRichTextView({ richtext }, ref);

  return (
    <Root {...props} className={clsx(className, classes?.root)} tabIndex={tabIndex}>
      <Slate editor={editor} value={value}>
        <Editable
          readOnly
          renderElement={ElementNode}
          renderLeaf={LeafNode}
          className={classes?.editable}
          {...slateEditableProps}
        />
        {children}
      </Slate>
    </Root>
  );
};

export default forwardRef(RichTextView);
